import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChamadoEmpresaListarComponent } from './chamado-empresa-listar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path: '',  component: ChamadoEmpresaListarComponent}
  ])],
  exports: [RouterModule]
})
export class ChamadoEmpresaListarRoutingModule { }
